import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_loader = _resolveComponent("account-loader")!
  const _component_role_tag = _resolveComponent("role-tag")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_user_clients_btn = _resolveComponent("user-clients-btn")!
  const _component_user_status = _resolveComponent("user-status")!
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_edit_user_btn = _resolveComponent("edit-user-btn")!
  const _component_delete_user_btn = _resolveComponent("delete-user-btn")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_account_loader, {
      "account-id": _ctx.accountId,
      modelValue: _ctx.account,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event))
    }, null, 8, ["account-id", "modelValue"]),
    (_ctx.isGranted('VIEW_USERS'))
      ? (_openBlock(), _createBlock(_component_q_table, {
          key: 0,
          columns: _ctx.columns,
          rows: _ctx.users,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
          loading: _ctx.isLoading,
          "wrap-cells": "",
          onRequest: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pagination = $event.pagination))
        }, {
          "body-cell-role": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                (props.value)
                  ? (_openBlock(), _createBlock(_component_role_tag, {
                      key: 0,
                      role: props.value
                    }, null, 8, ["role"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-clients": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_user_clients_btn, {
                  user: props.row
                }, null, 8, ["user"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-status": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_user_status, {
                  user: props.row,
                  "onUpdate:user": _ctx.setUser
                }, null, 8, ["user", "onUpdate:user"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-createdAt": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_humanize_time, {
                  time: props.value
                }, null, 8, ["time"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-actions": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_edit_user_btn, {
                  user: props.row,
                  flat: "",
                  round: "",
                  onSaved: _ctx.set
                }, null, 8, ["user", "onSaved"]),
                _createVNode(_component_delete_user_btn, {
                  user: props.row,
                  class: "on-right",
                  flat: "",
                  round: "",
                  onDeleted: _ctx.remove
                }, null, 8, ["user", "onDeleted"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["columns", "rows", "pagination", "loading"]))
      : _createCommentVNode("", true)
  ]))
}